import * as Antd from 'antd';

export const Loader = () => {
    return (
        <Antd.Flex align="center" justify="center" style={{
            width: '100vw',
            height: '100vh',
            position: 'fixed',
            top: 0,
            left: 0,
            zIndex: 10000,
        }}>
            <Antd.Spin size="large" />
        </Antd.Flex>
    );
};
